import { gql } from '@apollo/client';

// Mutation to update an existing ProductWork
// Corresponds to UpdateProductWork in app/testdb/schema/product_work/mutations.py
const UPDATE_PRODUCT_WORK_MUTATION = gql`
  mutation UpdateProductWork($id: ID!, $input: ProductWorkInput!) {
    updateProductWork(id: $id, input: $input) {
      ok
      productWork {
        id
        title
        description
        imprint {
          id
          value
        }
        series {
          id
          value
        }
        # Include any other fields needed upon update
      }
    }
  }
`;

export default UPDATE_PRODUCT_WORK_MUTATION;
